/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SomniaTokenContractInfo = {
    DPL: string;
    CTRXHA: string;
    TKNT: SomniaTokenContractInfo.TKNT;
    DCML: string;
};

export namespace SomniaTokenContractInfo {

    export enum TKNT {
        NA = 'NA',
        CA = 'CA',
        ERC20 = 'ERC20',
        ERC721 = 'ERC721',
        ERC1155 = 'ERC1155',
    }


}

